import React,{useState} from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { FormikTextField } from 'formik-material-fields';
import * as Yup from 'yup';

export default function QualityCheckStepContent(props) {
    const classes = useStyles();
    
    const [qualityCheckStepDetails, setQualityCheckStepDetails] = useState([])

    let shape = {}
    let buttonDisabled = true
    props.details.forEach(x => { x.type === 'text' ? (shape['check' + String(x.id)] = Yup.string().required("this check is required")) : shape['check' + String(x.id)] = Yup.string().notRequired() })

    let initialValues = {}
    let savedContent = props.savedContent.find(x => x.stepId === props.stepId)     
    if(savedContent){
        savedContent.details.forEach(x => initialValues['check' +String(x.id)] = x.name)      
        if(savedContent.details !== qualityCheckStepDetails){
            setQualityCheckStepDetails(savedContent.details) 
        }
    }else{
        props.details.forEach(x => { x.type === 'text' ? initialValues['check' + String(x.id)] = "" : initialValues['check' + String(x.id)] = "" }) 
    }
    
    function checkChanged(e,id){

        let tempQualityCheckStepDetails = Object.assign([], qualityCheckStepDetails);
        if(tempQualityCheckStepDetails.some(x => x.id === id)){
            tempQualityCheckStepDetails.find(x => x.id === id).name = e.target.value
            setQualityCheckStepDetails(tempQualityCheckStepDetails)
        }
        else{
            tempQualityCheckStepDetails.push({id:id, name:e.target.value})
            setQualityCheckStepDetails(tempQualityCheckStepDetails)
        }
    }

    return (
        <div className={classes.stepContent}>
            <Formik
            initialValues={initialValues}
            
                validationSchema={Yup.object().shape(shape)}
            >
                {({ isValid, touched }) => (                    
                    <Form autoComplete="off">
                        <div className={classes.qualityCheckInfo}>
                            {props.details.map(x =>
                                <React.Fragment key={x.id}>
                                    <div className={classes.label}>
                                        {x.label}
                                    </div>
                                    <div className={classes.input}>
                                        {x.type === "text" ? <FormikTextField  id="outlined-search" name={"check" + x.id} label="" type="search" variant="outlined" value={""} className={classes.formikTextField} size="small" onChange = {(e) => checkChanged(e, x.id)} />
                                            : <React.Fragment></React.Fragment>}
                                    </div>
                                    <div className={classes.info}>
                                    <img className={classes.infoIcon} src={process.env.PUBLIC_URL + '/img/info.svg'} alt={""}></img>
                                       <div className={classes.infoLabel}>{x.info}</div> 
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                        {Object.entries(touched).length === 0 && savedContent === undefined? buttonDisabled = true: buttonDisabled = false}                        
                        <div className={classes.nextStep}>
                            <Button className={classes.nextStepButton} disabled={!isValid || buttonDisabled} onClick={() => props.saveStep(qualityCheckStepDetails,props.stepId)}>{props.buttonText}</Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )

}

const useStyles = makeStyles((theme) => ({
    nextStepButton: {
        width: "300px",
        backgroundColor: "#5CC958",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        borderRadius: "6px",
        height: "40px",
        "&:hover": {
            background: "#5CC958"
        },  
    },
    nextStep:{
        width:"100%",
        height:"50px",
        textAlign:"center"
    },
    formikTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    label:{
        color: "#020100",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    },
    infoLabel:{
        color: "#8D8D8D",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        float:"left"
    },
    infoIcon:{
        marginRight:"3px",
        marginTop:"2px",
        float:"left"
    },
    info:{       
        marginBottom:"30px",
    }
}));